import { COMP_TYPES } from '../siteGeneratorUtilsConsts';

import type { CompStructure } from '@wix/document-services-types';

// copied from https://github.com/wix-private/santa-editor/blob/master/santa-editor/packages/util/sections/getBlankSectionStructure.ts
// TODO: consider moving both to one place, question is where
export const getBlankSectionStructure = ({
  height,
  y,
  name,
}: {
  height: number;
  y: number;
  name: string;
}): CompStructure => {
  return {
    anchor: {
      name: name,
      type: 'AnchorInfo',
    } as CompStructure['anchor'],
    design: {
      type: 'MediaContainerDesignData',
      background: {
        mediaRef: null,
        fittingType: 'fill',
        alignType: 'center',
        colorOverlay: '',
        colorOverlayOpacity: 1,
        color: 'color_11',
        colorOpacity: 0,
        type: 'BackgroundMedia',
        imageOverlay: '',
        scrollType: 'none',
      },
    },
    components: [],
    componentType: COMP_TYPES.SECTION,
    layout: {
      x: 0,
      y,
      scale: 1,
      height,
      rotationInDegrees: 0,
      width: 980,
    },
    type: 'Container',
    props: {
      type: 'ClassicSectionProperties',
    },
  };
};
